"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionContext = void 0;
var React = require("react");
exports.AccordionContext = React.createContext({
    collapseAll: false,
    expandedContentId: '',
    isAccordion: true,
});
